// Lightweight analytics shim. Currently console-only as requested.
// To swap to GA/Mixpanel later, replace the body of `track`.
export const track = (event, payload = {}) => {
  try {
    console.log(`[analytics] ${event}`, payload);
  } catch (_) {
    // ignore
  }
};
